import ImportTrans from './ImportTrans.vue';

export default ImportTrans;


// WEBPACK FOOTER //
// ./src/components/ImportTrans/index.js